"use strict";
exports.__esModule = true;
/**
 * Takes an Action which either receives a callback or returns a promise,
 * and awaits the appropriate thing.
 *
 * If the action returns a 'thenable', that is awaited.  Otherwise, a new
 * promise object is returned which is resolved when the callback is called.
 */
function promisify(action) {
    var returnedPromise;
    var cbPromise = new Promise(function (resolve, reject) {
        returnedPromise = action(function (err, result) {
            if (err) {
                reject(err);
            }
            else {
                resolve(result);
            }
        });
    });
    if (returnedPromise &&
        typeof returnedPromise == 'object' &&
        'then' in returnedPromise) {
        return returnedPromise;
    }
    return cbPromise;
}
exports.promisify = promisify;
/**
 * Takes an Action which either receives a callback or returns a promise,
 * and awaits the appropriate thing.
 *
 * If the action returns a 'thenable', that is awaited and the cb is called
 * when it finishes.  Otherwise, the callback is called directly by the action.
 */
function callbackify(action, cb) {
    var returnedPromise = action(cb);
    if (returnedPromise &&
        typeof returnedPromise == 'object' &&
        'then' in returnedPromise) {
        returnedPromise.then(function (value) { return cb(null, value); }, function (err) { return cb(err); });
    }
}
exports.callbackify = callbackify;
//# sourceMappingURL=promisify.js.map